// extracted by mini-css-extract-plugin
module.exports =  {"container":"ChartAreaWrapper-module__container--YfuMw"};